import { cn } from "@/modules/lib/utils"
import backgroundBenchmark from "@images/backgroundBenchmark.png"
import errorInvitationShareCoach from "@images/error/errorInvitationShareCoach.svg"
import InvitationIcon from "@images/invitationIcon.svg"
import { word } from "@modules/core/utils/i18n"
import { Text } from "@/components/ui/baseUi/text"

export function MemberOfferInvitationError({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div className={cn("flex h-[90vh] flex-col gap-6", className)} {...props}>
      {/* HEADER */}
      <div className="relative flex h-60 overflow-hidden rounded-b-3xl bg-neutral-200">
        <div className="mt-2 ml-1 flex h-full w-1/2 flex-col items-center justify-center gap-2">
          <div
            className="bg-contain bg-center bg-no-repeat"
            style={{ backgroundImage: `url('${InvitationIcon} ')`, width: "60px", height: "60px" }}
          ></div>
          <Text fontStyle="HM" className="text-textDefault-heading">
            {word("member.offer.invitationError.title")}
          </Text>
          <Text fontStyle="BM" className="text-textDefault-body">
            {word("member.offer.invitationError.subtitle")}
          </Text>
        </div>
        <div
          className="h-full w-1/2 bg-cover bg-right bg-no-repeat"
          style={{
            background: `url('${backgroundBenchmark}')`,
            clipPath: "polygon(43% 0, 100% 0, 100% 100%, 0% 100%)",
            WebkitClipPath: "polygon(43% 0, 100% 0, 100% 100%, 0% 100%)",
          }}
        ></div>
      </div>
      {/* CONTENT */}
      <div className="mx-5 flex flex-col items-center justify-center gap-2 rounded-2xl bg-surface-background-secondary p-5">
        <Text fontStyle="HS" className="text-textDefault-caption">
          {word("member.offer.invitationError.content")}
        </Text>
        <Text fontStyle="BM" className="px-15 text-center text-textDefault-body">
          {word("member.offer.invitationError.subcontent")}
        </Text>
        <div
          className="h-48 w-full bg-contain bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${errorInvitationShareCoach})` }}
        ></div>
      </div>
    </div>
  )
}
